import { IntegrationType } from "@nova/schemas"
import type { IntegrationAuthorizationResponse } from "@nova/data-facade"
import { getApiGatewayDomain } from "@nova/fetch-api-gateway"

const getIntegrationOAuthLink = (
    integration: IntegrationType,
    workspaceId: string,
    options: { windowType: "tab" | "window" } = { windowType: "tab" }
) => {
    const queryParams = new URLSearchParams({ windowType: options.windowType })

    return `${getApiGatewayDomain()}/org/${workspaceId}/integrations/${integration.toString()}/authorize?${queryParams.toString()}`
}

const buildOAuthPopup = (integration: IntegrationType, workspaceId: string) => {
    let success = false
    return new Promise<void>((resolve, reject) => {
        const popup = window.open(
            getIntegrationOAuthLink(integration, workspaceId, {
                windowType: "window",
            }),
            "oauthPopup",
            "width=500,height=600"
        )

        if (!popup) {
            reject(new Error("Popup blocked"))
            return
        }

        const messageListener = (e: MessageEvent) => {
            if (e.data?.type !== "oauthResult") return

            if (!e.data?.success) {
                reject(new Error("Failed to authorize"))
                success = false
                return
            }

            success = true
        }

        addEventListener("message", messageListener)

        // Poll window to check if promise should resolve
        const interval = setInterval(() => {
            if (popup.closed) {
                removeEventListener("message", messageListener)
                clearInterval(interval)
                if (success) {
                    resolve()
                } else {
                    reject()
                }
            }
        }, 500)
    })
}

const isAuthExpired = (auth: IntegrationAuthorizationResponse) =>
    auth.expires && auth.expires <= Date.now()

export { getIntegrationOAuthLink, buildOAuthPopup, isAuthExpired }
